module.exports = __webpack_public_path__ + "static/media/WAF1_13Feb1983.bcff422f.jpg";